module.exports = __webpack_public_path__ + "static/media/LogicWheel6_2_drag_1.1ce0febd.png";